//export class OrganisationListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: OrganisationListPageComponent, isMenuHidden: true }];
//};

import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/OrganisationDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class OrganisationEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/organisation"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/organisation/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/organisation/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/organisation/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/organisation/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/organisation/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/organisation/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

let organisationListEndPoint: IDataEndPoint = { url: app.config.controllerRouteRoot + "/organisation", method: "GET" };

export class OrganisationFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public selected: IFieldOptions = { field: "selected" };
	public parentId: IFieldOptions = { field: "parentId", dataEndPoint: organisationListEndPoint, dataIdField: "id", dataDisplayField: "name" };
	public typeId: IFieldOptions = { field: "typeId" };
	public name: IFieldOptions = { field: "name" };
	public description: IFieldOptions = { field: "description" };
	public defaultUserId: IFieldOptions = { field: "defaultUserId" };
	public defaultRoleId: IFieldOptions = { field: "defaultRoleId" };
	public changedBy: IFieldOptions = { field: "changedBy" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public status: IFieldOptions = { field: "status" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.selected);
		this.push(this.parentId);
		this.push(this.typeId);
		this.push(this.name);
		this.push(this.description);
		this.push(this.defaultUserId);
		this.push(this.defaultRoleId);
		this.push(this.changedBy);
		this.push(this.datestamp);
		this.push(this.status);
	}
}

export class OrganisationForm implements IFormOptions {
	protected organisationFormName: string = "organisationForm";
	protected organisationFormModel: models.OrganisationDTO = new models.OrganisationDTO();
	protected organisationFormEndPoints: OrganisationEndPoints = new OrganisationEndPoints();
	protected organisationFormFields: OrganisationFormFields = new OrganisationFormFields();
	public get name(): string { return this.organisationFormName };
	public get model(): models.OrganisationDTO { return this.organisationFormModel };
	public get endPoints(): IEntityEndPoints { return this.organisationFormEndPoints };
       public set endPoints(organisationEndPoints: IEntityEndPoints) {
		this.organisationFormEndPoints = organisationEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): OrganisationFormFields { return this.organisationFormFields };
}

export class OrganisationListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public selected: IColumnOptions = { field: "selected" };
	public parentId: IColumnOptions = { field: "parentId" };
	public typeId: IColumnOptions = { field: "typeId" };
	public name: IColumnOptions = { field: "name" };
	public description: IColumnOptions = { field: "description" };
	public defaultUserId: IColumnOptions = { field: "defaultUserId" };
	public defaultRoleId: IColumnOptions = { field: "defaultRoleId" };
	public changedBy: IColumnOptions = { field: "changedBy" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public status: IColumnOptions = { field: "status" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.selected);
		this.push(this.parentId);
		this.push(this.typeId);
		this.push(this.name);
		this.push(this.description);
		this.push(this.defaultUserId);
		this.push(this.defaultRoleId);
		this.push(this.changedBy);
		this.push(this.datestamp);
		this.push(this.status);
	}
}

export class OrganisationList implements IGridOptions {
	protected organisationListName: string = "organisationList";
	protected organisationListModel: models.OrganisationDTO = new models.OrganisationDTO();
	protected organisationListEndPoints: OrganisationEndPoints = new OrganisationEndPoints();
	protected organisationListColumns: OrganisationListColumns = new OrganisationListColumns();
	public organisationForm: OrganisationForm = new OrganisationForm();
	public get name(): string { return this.organisationListName };
	public get model(): models.OrganisationDTO { return this.organisationListModel };
	public get endPoints(): IEntityEndPoints { return this.organisationListEndPoints };
	public set endPoints(organisationEndPoints: IEntityEndPoints) {
		this.organisationListEndPoints = organisationEndPoints;
		this.organisationForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): OrganisationListColumns { return this.organisationListColumns };
}

export class OrganisationEntity implements IEntityOptions {
	protected organisationEntityName: string = "organisationEntity";
	protected organisationEntityModel: models.OrganisationDTO = new models.OrganisationDTO();
	protected organisationEntityEndPoints: OrganisationEndPoints = new OrganisationEndPoints();
	protected organisationEntityList: OrganisationList = new OrganisationList();
	public get name(): string { return this.organisationEntityName };
	public get model(): models.OrganisationDTO { return this.organisationEntityModel };
	public get endPoints(): IEntityEndPoints { return this.organisationEntityEndPoints };
	public set endPoints(organisationEndPoints: IEntityEndPoints) {
		this.organisationEntityEndPoints = organisationEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): OrganisationList { return this.organisationEntityList };
	public get form(): OrganisationForm { return this.grid.organisationForm };
	constructor(name?: string) {
		if (name) this.organisationEntityName = name;
		this.endPoints = this.organisationEntityEndPoints;
	}
};
//export class OrganisationGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: OrganisationForm = new OrganisationForm();
//};

//export class OrganisationListPageComponent extends ListPageComponent {
  //protected listPageComponentList: OrganisationList = new  OrganisationList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class OrganisationBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: OrganisationGeneratedForm}];
//};

